import { LoanRolloverSplitParams } from 'app/models/loan-rollover-split-params'
import * as types from './types'
import { createReducer } from 'app/state/utils'

export interface LoanRolloverSplitState {
  approvedLoanRolloverSplits: LoanRolloverSplitParams[]
  loanRolloverSplits: LoanRolloverSplitParams[]
  isLoading: boolean
}

const initialState: LoanRolloverSplitState = {
  approvedLoanRolloverSplits: [],
  loanRolloverSplits: [],
  isLoading: false,
}

const loanRolloverSplitsReducer = createReducer(initialState)({
  [types.GET_LOAN_ROLLOVER_SPLITS]: (state: any, payload: any) => {
    return { ...state, loanRolloverSplits: payload.payload }
  },

  [types.GET_APPROVED_LOAN_ROLLOVER_SPLITS]: (state: any, payload: any) => {
    return { ...state, approvedLoanRolloverSplits: payload.payload }
  },

  [types.EDIT_LOAN_ROLLOVER_SPLIT]: (state: any, payload: any) => {
    const index = state.loanRolloverSplits.findIndex(
      (split: { id: any }) => split.id === payload.payload.data.id,
    )
    const newArray = [...state.loanRolloverSplits]
    newArray[index] = { ...payload.payload.data, status: 'Draft' }
    return {
      ...state,
      loanRolloverSplits: newArray,
    }
  },

  [types.ADD_LOAN_ROLLOVER_SPLIT]: (state: any, payload: any) => {
    return {
      ...state,
      loanRolloverSplits: [
        { ...payload.payload.data, status: 'Draft' },
        ...state.loanRolloverSplits,
      ],
    }
  },

  [types.SUBMIT_LOAN_ROLLOVER_SPLIT]: (state: any, payload: any) => {
    return {
      ...state,
      loanRolloverSplits: state.loanRolloverSplits.map(
        (split: LoanRolloverSplitParams) =>
          split.id === payload.payload.id
            ? { ...split, status: 'Submitted' }
            : split,
      ),
    }
  },

  [types.APPROVE_LOAN_ROLLOVER_SPLIT]: (state: any, payload: any) => {
    const existing = state.loanRolloverSplits.find(
      (split: LoanRolloverSplitParams) => split.id === payload.payload.id,
    )
    return {
      ...state,
      loanRolloverSplits: state.loanRolloverSplits.map(
        (split: LoanRolloverSplitParams) =>
          split.id === payload.payload.id
            ? { ...split, status: 'Approved' }
            : split,
      ),
      approvedLoanRolloverSplits: existing
        ? [...state.approvedLoanRolloverSplits, { ...existing, status: 'Approved' }]
        : state.approvedLoanRolloverSplits,
    }
  },

  [types.REJECT_LOAN_ROLLOVER_SPLIT]: (state: any, payload: any) => {
    return {
      ...state,
      loanRolloverSplits: state.loanRolloverSplits.map(
        (split: LoanRolloverSplitParams) =>
          split.id === payload.payload.id
            ? { ...split, status: 'Draft' }
            : split,
      ),
    }
  },

  [types.DELETE_LOAN_ROLLOVER_SPLIT]: (state: any, payload: any) => {
    return {
      ...state,
      loanRolloverSplits: state.loanRolloverSplits.filter(
        (split: LoanRolloverSplitParams) => split.id !== payload.payload.id,
      ),
    }
  },
  [types.START_LOADING_LOAN_ROLLOVER_SPLIT]: (state: any) => {
    return { ...state, isLoading: true }
  },
  [types.STOP_LOADING_LOAN_ROLLOVER_SPLIT]: (state: any) => {
    return { ...state, isLoading: false }
  },
})

export default loanRolloverSplitsReducer
